import { route } from "../../../../application/domain/routing/named-route";
import { MatrixCodePageContainer } from "./matrix-code";

export const ServiceProviderGrafferUtilityToolsRoutes = {
  MatrixCode: route({
    path: "/service-provider/graffer-utility-tools/matrix-code",
    link: () => `/service-provider/graffer-utility-tools/matrix-code`,
    component: MatrixCodePageContainer,
  }),
};
